<template>
  <div class="white-box position-relative">
    <TileLoader :loading="loading"/>
    <h2>Evolutions CA/RFA</h2>
    <table class="datas-table">
      <thead>
      <tr>
        <th>Période</th>
        <th class="number">CA</th>
        <th class="number">Tx RFA Fixe</th>
        <th class="number">Tx RFA Ind.</th>
        <th class="number">Tx RFA Totale</th>
        <th class="number">RFA Totale</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="row of datas" :key="row.Label">
        <td>{{ row.Label }}</td>

        <td class="number">{{ formatEuro(row.CA, 0) }}
          <div class="trend-indicator" v-if="Math.round(row.ProgressionCA * 10000)" :class="row.ProgressionCA >= 0 ? 'up' : 'down'">
            {{ Math.round(row.ProgressionCA * 10000) / 100 }}&nbsp;%
          </div>
          <div v-else class="text-muted">
            -
          </div>
        </td>

        <td class="number" v-if="row.TxFixe || row.ProgressionTxFixe">{{ Math.round(row.TxFixe * 10000) / 100 }} %
          <div v-if="Math.round(row.ProgressionTxFixe * 10000)" class="trend-indicator" :class="row.ProgressionTxFixe >= 0 ? 'up' : 'down'">
            {{ Math.round(row.ProgressionTxFixe * 10000) / 100 }}
          </div>
          <div v-else class="text-muted">
            -
          </div>
        </td>
        <td v-else class="number text-muted">N/A</td>

        <td class="number" v-if="row.TxInd || row.ProgressionTxInd">{{ Math.round(row.TxInd * 10000) / 100 }} %
          <div v-if="Math.round(row.ProgressionTxInd * 10000)" class="trend-indicator" :class="row.ProgressionTxInd >= 0 ? 'up' : 'down'">
            {{ Math.round(row.ProgressionTxInd * 10000) / 100 }}
          </div>
          <div v-else class="text-muted">
            -
          </div>
        </td>
        <td v-else class="number text-muted">N/A</td>

        <td class="number" v-if="row.TxTot || row.ProgressionTxTot">{{ Math.round(row.TxTot * 10000) / 100 }} %
          <div v-if="Math.round(row.ProgressionTxTot * 10000)" class="trend-indicator" :class="row.ProgressionTxTot >= 0 ? 'up' : 'down'">
            {{ Math.round(row.ProgressionTxTot * 10000) / 100 }}
          </div>
          <div v-else class="text-muted">
            -
          </div>
        </td>
        <td v-else class="number text-muted">N/A</td>

        <td class="number" v-if="row.RfaTot || row.ProgressionRfaTot">{{ formatEuro(row.RfaTot, 0) }}
          <div v-if="Math.round(row.ProgressionRfaTot * 10000)" class="trend-indicator" :class="row.ProgressionRfaTot >= 0 ? 'up' : 'down'">
            {{ Math.round(row.ProgressionRfaTot * 10000) / 100 }}&nbsp;%
          </div>
          <div v-else class="text-muted">
            -
          </div>
        </td>
        <td v-else class="number text-muted">N/A</td>

      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
import TileLoader from "../../Dashboards/TileLoader.vue";
import {getFrsCaRfaInfos, getPaymentsFrs} from "@/utils/dashboardCdm";

export default {
  components: {TileLoader},
  name: 'FrsCaRfaInfosTile',
  props: ["frsGuid"],
  data() {
    return {
      loading: 0,
      datas: []
    }
  },
  mounted() {
    this.initData();
  },
  watch: {
    frsGuid() {
      this.initData();
    }
  },
  methods: {
    initData() {
      if (!this.frsGuid) return;

      this.loading = 1;
      getFrsCaRfaInfos(this.frsGuid).then(res => {
        if (res.length)
          this.datas = res;
        this.loading = 0;
      })
    },
    formatEuro(value, precision = 2) {
      return Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR', maximumFractionDigits: precision}).format(value);
    },
  },
  computed: {}
}
</script>

<style scoped>
.white-box {
  flex: 1 1 max-content;
  padding: 12px;

  display: flex;
  flex-direction: column;
}

h2 {
  display: flex;
  align-items: center;

  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

p {
  margin: 0;
}

.datas-table thead {
  border-bottom: 1px solid black;
}

.datas-table th, .datas-table td {
  padding: 2px 8px;
}

.datas-table tbody tr:nth-child(odd) {
  background-color: #EFEFEF;
}

.datas-table tbody tr:nth-child(even) {
  background-color: #C5C5C5;
}

.datas-table td.with-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}
.datas-table .number {
  text-align: right;
}

.datas-table .tag > div {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.datas-table .tag > div.green {
  background-color: #388E3C;
}

.datas-table .tag > div.orange {
  background-color: #FFC107;
}

.datas-table .tag > div.red {
  background-color: #D32F2F;
}

.trend-indicator {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  font-size: 0.8em;
}

.trend-indicator.up {
  color: #388E3C;
}

.trend-indicator.up::before {
  content: url('data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20fill%3D%22none%22%20stroke%3D%22%23388E3C%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%3E%3Cpath%20d%3D%22m3%2017l6-6l4%204l8-8%22%2F%3E%3Cpath%20d%3D%22M17%207h4v4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
}

.trend-indicator.down {
  color: #D32F2F;
}

.trend-indicator.down::before {
  content: url('data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20fill%3D%22none%22%20stroke%3D%22%23D32F2F%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%3E%3Cpath%20d%3D%22m3%207l6%206l4-4l8%208%22%2F%3E%3Cpath%20d%3D%22M17%2017h4v-4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
}

</style>



// WEBPACK FOOTER //
// src/components/DashboardCdm/RecapPage/FrsCaRfaInfosTile.vue